import React, { Children } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, SendIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Contact() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="contact" className="py-20 px-4" data-id="element-51">
      <div className="container mx-auto max-w-5xl" data-id="element-52">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-54">
            Get In Touch
          </h2>
          <div className="w-20 h-1 bg-purple-600 mx-auto" data-id="element-55"></div>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-10" data-id="element-56">
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-57">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-58">
              Contact Information
            </h3>
            <div className="space-y-6" data-id="element-59">
              <motion.div className="flex items-start" variants={itemVariants} data-id="element-60">
                <div className="mr-4 bg-purple-100 p-3 rounded-full" data-id="element-61">
                  <MailIcon size={24} className="text-purple-600" data-id="element-62" />
                </div>
                <div data-id="element-63">
                  <h4 className="text-lg font-medium text-gray-800" data-id="element-64">Email</h4>
                  <a href="mailto:habeeb.adiatu@iit.ci" className="text-gray-600 hover:text-purple-600" data-id="element-65">
                    habeeb.adiatu@iit.ci
                  </a>
                </div>
              </motion.div>
              <motion.div className="flex items-start" variants={itemVariants} data-id="element-66">
                <div className="mr-4 bg-purple-100 p-3 rounded-full" data-id="element-67">
                  <PhoneIcon size={24} className="text-purple-600" data-id="element-68" />
                </div>
                <div data-id="element-69">
                  <h4 className="text-lg font-medium text-gray-800" data-id="element-70">Phone</h4>
                  <div className="space-y-1" data-id="element-71">
                    <a href="tel:+2250576696337" className="block text-gray-600 hover:text-purple-600" data-id="element-72">
                      +225 0576696337
                    </a>
                    <a href="tel:+2250713681278" className="block text-gray-600 hover:text-purple-600" data-id="element-73">
                      +225 0713681278
                    </a>
                  </div>
                </div>
              </motion.div>
              <motion.div className="flex items-start" variants={itemVariants} data-id="element-74">
                <div className="mr-4 bg-purple-100 p-3 rounded-full" data-id="element-75">
                  <MapPinIcon size={24} className="text-purple-600" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <h4 className="text-lg font-medium text-gray-800" data-id="element-78">
                    Location
                  </h4>
                  <p className="text-gray-600" data-id="element-79">Yopougon, Abidjan, CI</p>
                </div>
              </motion.div>
            </div>
            <motion.div className="mt-8" variants={itemVariants} data-id="element-80">
              <h4 className="text-lg font-medium text-gray-800 mb-4" data-id="element-81">
                Follow Me
              </h4>
              <div className="flex space-x-4" data-id="element-82">
                <motion.a href="#" className="bg-gray-200 p-3 rounded-full text-gray-600 hover:bg-purple-600 hover:text-white transition-colors duration-300" aria-label="GitHub" whileHover={{
                scale: 1.1,
                backgroundColor: '#9333ea',
                color: '#ffffff'
              }} data-id="element-83">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-84">
                    <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-85"></path>
                  </svg>
                </motion.a>
                <motion.a href="#" className="bg-gray-200 p-3 rounded-full text-gray-600 hover:bg-purple-600 hover:text-white transition-colors duration-300" aria-label="LinkedIn" whileHover={{
                scale: 1.1,
                backgroundColor: '#9333ea',
                color: '#ffffff'
              }} data-id="element-86">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-87">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-88" />
                  </svg>
                </motion.a>
                <motion.a href="#" className="bg-gray-200 p-3 rounded-full text-gray-600 hover:bg-purple-600 hover:text-white transition-colors duration-300" aria-label="Twitter" whileHover={{
                scale: 1.1,
                backgroundColor: '#9333ea',
                color: '#ffffff'
              }} data-id="element-89">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-90">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-91" />
                  </svg>
                </motion.a>
                <motion.a href="#" className="bg-gray-200 p-3 rounded-full text-gray-600 hover:bg-purple-600 hover:text-white transition-colors duration-300" aria-label="Instagram" whileHover={{
                scale: 1.1,
                backgroundColor: '#9333ea',
                color: '#ffffff'
              }} data-id="element-92">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-93">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-94" />
                  </svg>
                </motion.a>
              </div>
            </motion.div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-95">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-96">
              Send Me a Message
            </h3>
            <form data-id="element-97">
              <div className="mb-4" data-id="element-98">
                <label htmlFor="name" className="block text-gray-700 mb-2" data-id="element-99">
                  Name
                </label>
                <motion.input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Your name" required whileFocus={{
                boxShadow: '0 0 0 3px rgba(147, 51, 234, 0.2)'
              }} data-id="element-100" />
              </div>
              <div className="mb-4" data-id="element-101">
                <label htmlFor="email" className="block text-gray-700 mb-2" data-id="element-102">
                  Email
                </label>
                <motion.input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Your email" required whileFocus={{
                boxShadow: '0 0 0 3px rgba(147, 51, 234, 0.2)'
              }} data-id="element-103" />
              </div>
              <div className="mb-4" data-id="element-104">
                <label htmlFor="subject" className="block text-gray-700 mb-2" data-id="element-105">
                  Subject
                </label>
                <motion.input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Subject" required whileFocus={{
                boxShadow: '0 0 0 3px rgba(147, 51, 234, 0.2)'
              }} data-id="element-106" />
              </div>
              <div className="mb-6" data-id="element-107">
                <label htmlFor="message" className="block text-gray-700 mb-2" data-id="element-108">
                  Message
                </label>
                <motion.textarea id="message" rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Your message" required whileFocus={{
                boxShadow: '0 0 0 3px rgba(147, 51, 234, 0.2)'
              }} data-id="element-109"></motion.textarea>
              </div>
              <motion.button type="submit" className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-md font-medium transition duration-300 flex items-center" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} data-id="element-110">
                Send Message
                <SendIcon size={18} className="ml-2" data-id="element-111" />
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}